// extracted by mini-css-extract-plugin
export default {"wrapper":"SiteQrCode_wrapper__66-2M","qrCodeWrapper":"SiteQrCode_qrCodeWrapper__hyJze","qrCode":"SiteQrCode_qrCode__LWJJF","text":"SiteQrCode_text__CwlX0"};